/* eslint-disable */
export default {
  dncAlert: '이 연락처는 발신 금지 목록에 있습니다.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
